// extracted by mini-css-extract-plugin
export default {"header":"Cells_header__PzpNX","row":"Cells_row__n-Tqt","rowLvl2":"Cells_rowLvl2__RAWHW","placeHolderShimmer":"Cells_placeHolderShimmer__xJJJQ"};